import UserStore from '../../stores/UserStore';

class BarcodeScanner extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            minCodeLength   : 4,
            barcode         : '',
            time            : 0,
            tmpResults      : [],
            endResults      : false,
        };

        this.scanner           = this.scanner.bind(this);
        this.scanIsComplete    = this.scanIsComplete.bind(this);
    }

    componentDidMount() {
        // document.addEventListener('keypress', this.scanner);
        document.addEventListener('keydown', this.scanner); // v1.1
    }

    componentWillUnmount() {
        // document.removeEventListener('keypress', this.scanner);
        document.removeEventListener('keydown', this.scanner); // v1.1
    }

    scanner(e) {
        // TO STOP SCANNING IF ANY INPUT IS IN FOCUS
        if ($('input:focus,textarea:focus').length !== 0)
            return;

        var self        = this;
        var key         = e.which;
        var LspId       = parseInt(UserStore.getApiData().LspId);

        /* DONT LET TAB CHANGE FOCUS TO ADDRESS BAR */
        if (key === 9)
            e.preventDefault();

        // SWE KEYBOARD LAYOUT GIVES DIFFERENT RESULTS

        // (-) DASH SIGN
        // ENG = 45
        // SWE = 43

        if (key === 43)
            key = 45;

        // (+) PLUS SIGN
        // ENG = 43
        // SWE = 96

        if (key === 96)
            key = 43;

        var prevTime    = this.state.time;
        //var timeStamp   = e.timeStamp.toFixed(3);
        var timeStamp = new Date().getTime()
        var diff        = timeStamp - prevTime;
        var timeResolution = 400;

        var tmpResults  = [];
        if (diff < timeResolution)
            tmpResults = this.state.tmpResults ? this.state.tmpResults : [];

        // GREENHOUSE - 1041
        // if (LspId === 1041) {
        if (key === 192 || key === 220)
            return;
        // }

        if (key === 10 || key === 16 || key === 17 || key === 27 || key === 32 || key === 0) {
            return;
        }    

        tmpResults.push({
            // USE this.convertToDecimal IF WE WANT TO CHANGE jQuery CHARS
            keycode : String.fromCharCode(this.convertToDecimal(key)), // v1.1

            // keycode : String.fromCharCode(key),
            decimal : this.convertToDecimal(key),
            jquery  : key,
            time    : diff.toFixed(2),
        });

        this.setState({
            time        : timeStamp,
            tmpResults  : tmpResults
        }, () => {

            // DETECT ENTER (13) OR TAB (9)
            // MIN LENGTH 4 CHAR
            if ((e.code === 'Enter' || e.code === 'Tab' || key === 9 || key === 13) && tmpResults.length > this.state.minCodeLength) {

                // SOME BROWSERS ADD CHARACTERS IN THE BEGINNING
                // TIMING IS OFF SO WE CAN DETECT IT FROM THAT
                // FF       - 74
                // EDGE     - 10
                // IE       - NO EXTRA CHAR
                // CHROME   - NO EXTRA CHAR
                if (tmpResults[1].time - tmpResults[0].time > 200)
                    tmpResults.splice(0, 1);

                var barcode = '';
                for (var i=0; i<tmpResults.length; i++) {
                    if (tmpResults[i].decimal > 32 && tmpResults[i].decimal <= 200)
                        barcode = barcode+''+tmpResults[i].keycode;
                }

                self.setState({
                    barcode         : barcode,
                    tmpResults      : false,
                    endResults      : tmpResults
                }, self.scanIsComplete);
            }
        });
    }

    scanIsComplete() {
        // IF THE SCANNER ENDS WITH TAB, WE DON'T WANT FOCUS TO THE URL BAR
        $('#hiddenTab').focus();

        var self            = this;
        var barcode         = this.state.barcode;
        var endResults      = this.state.endResults;

        if (barcode.length < this.state.minCodeLength)
            return;

        if (endResults[0].decimal === 43) {
            // ga('send', 'event', 'Scale');

            if ($('#bulk-weight').length) {
                while (barcode.length > 0 && (barcode[0] === '+' || barcode[0] === '0'))
                    barcode = barcode.slice(1);

                if (this.props.onScale)
                    this.props.onScale(barcode);
            }
        } else {
            this.props.onScan(barcode, true);
        }
    }

    convertToDecimal(val) {
        switch (val)
        {
            // DASH
            case 173:
            case 189:
                return 45;
                break;

            // PERIOD
            case 190:
                return 46;
                break;

            // FORWARD SLASH
            case 191:
                return 47;
                break;

            // PLUS
            case 61:
            case 187:
            case 219:
                return 43;
                break;

            // BACK SLASH
            case 220:
                return 92;
                break;

            default:
                return val;
        }
    }


    ignoreKeyCode(key) {
        switch (key)
        {
            // RIGHT ARROW
            case 39:
                return true;

            // LEFT ARROW
            case 37:
                return true;

            // UP ARROW
            case 38:
                return true;

            // DOWN ARROW
            case 40:
                return true;

            default:
                return false;
        }
    }

    render() {
        return null;
    }
}

export default BarcodeScanner;


// WEBPACK FOOTER //
// ./ui_src/app/components/scanner/BarcodeScanner.react.jsx